<template>
  <div class="setup-account" style="height: 100%;">
    <top></top>
    <div class="titlr">
      <h3>My Plan</h3>
    </div>
    <div class="plan">
      <div class="show-plan">
        <div class="current">
          <h3>{{ current_plan }} <span v-if="$store.getters.ISTRIAL">(Trial)</span></h3>
          <p>Total Space: {{ $sizeFormat(total_space) }}</p>
          <p v-if="is_subscription_active">{{ daysLeft() }} days left to expiration</p>
          <p v-if="is_trial">
            <template v-if="!days_left">
              <span class="badge badge-danger">Your trial period has elapsed</span>
            </template>
            <template v-if="days_left">
              {{ days_left }} days left to expiration
            </template>
          </p>
        </div>
        <div class="upgrade">
          <template v-if="account_type == 1">
            <template v-if="user_plan == 2">
              <router-link to="/payments-billing" v-if="is_trial" class="button">Pay Now</router-link>
              <span v-if="is_subscription_active" class="button">Renew</span>
            </template>
            <template v-if="user_plan == 1">
              <router-link to="/payments-billing" class="button">Upgrade Now</router-link>
            </template>
          </template>
          <template v-if="account_type == 2">
            <router-link to="/payments-billing" v-if="is_trial" class="button">Pay Now</router-link>
            <span v-if="is_subscription_active" class="button">Renew</span>
          </template>
        </div>
      </div>
      <div class="loader" v-if="loader">
        <svg width="120px" height="120px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid" class="lds-dual-ring"
          style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
          <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
            stroke-dasharray="31.41592653589793 31.41592653589793">
            <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
              keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
          </circle>
        </svg>
        <span>Loading...</span>
      </div>
    </div>
    <logout ref="logout"></logout>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
.show-plan {
  display: flex;
  align-items: center;
  justify-content: center;
}

.current {
  padding: 5em 6em;
}

a:hover {
  text-decoration: none;
}

.upgrade {
  padding: 5em 6em;
  border-left: 1px solid rgb(204, 204, 204);
}

.upgrade .button {
  background-color: rgb(255, 177, 8);
  color: #000;
  border-radius: 3px;
  font-size: 18px;
  padding: .9em 1.6em;
  cursor: pointer;
  border: 1px solid rgb(218, 150, 5);
}

.loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loader span {
  display: inline;
}

.titlr {
  margin: 2em 0;
}

.plan {
  background-color: rgb(252, 252, 252);
  border: 1px solid #e2e2e2;
  padding: 1em;
  margin: 0 auto;
  width: 80%;
}
</style>

<script>
import top from '@/components/Top'
import logout from '@/components/Logout'
import { mapMutations } from 'vuex'
import { setTimeout } from 'timers'
import cookies from '@/services/cookies'
import loading from '@/components/Loading'
import moment from 'moment'
export default {
  components: {
    top,
    logout,
    loading
  },
  data() {
    return {
      loader: false,
      current_plan: '',
      total_space: '',
      total_used: '',
      is_trial: false,
      account_type: '',
      days_left: '',
      is_subscription_active: false,
      expiration_date: '',
      user_plan: ''
    }
  },
  methods: {
    logout() {
      this.$refs.logout.logout()
    },
    ...mapMutations([
      'SET_FILE_ACTION',
      'REMOVE_FILE_ACTION',
      'SET_DIRECTORY_CHILDREN',
      'TOGGLE_FILE_INFO',
      'SORT_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'GET_DIRECTORY_CHILDREN',
      'CLOSE_FILE_INFO',
      'SET_PATH',
      'UPDATE_SLIDEIN',
      'UPDATE_SLIDEOUT',
      'UPDATE_BODY_MENU',
      'UPDATE_MENU',
      'UPDATE_TOTAL_CREATED_IMAGES',
      'UPDATE_TOTAL_CREATED_DOCUMENTS',
      'UPDATE_TOTAL_CREATED_FOLDERS',
      'SET_FIRSTNAME',
      'SET_LASTNAME',
      'SET_EMAIL',
      'SET_PHONE',
      'SET_POSITION',
      'SET_DEPARTMENT',
      'SET_COUNTRY',
      'SET_DATE_CREATED',
      'SET_ACCT_TYPE',
      'SET_ISADMIN',
      'SET_PHOTO',
      'UPDATE_TOTAL_SPACE',
      'UPDATE_DEFAULT_FOLDER',
      'UPDATE_TOTAL_USED_SPACE',
      'SET_ISTRIAL',
      'SET_ISSTAFF',
      'SET_ISSUPERADMIN',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'HIDE_FILE_INFO',
      'SET_FILE_ACTION',
      'SET_SELECT_ALL',
      'UPDATE_USER',
      'SET_CURRENT_PLAN',
      'UPDATE_PUBLIC_FOLDER_ID',
      'SET_NAME',
      'SET_USER_PLAN',
      'SET_IS_SECURITY_QUESTION',
      'SET_PLAN_STATUS',
      'SET_TRIAL_STATUS',
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    daysLeft() {
      let cur = moment(moment.now())
      let foundtime = moment(this.expiration_date)
      let days = foundtime.diff(cur, 'days')
      return days === 0 || 0 > days ? 0 : days
    },
    user_data() {
      let data = {
        token: cookies.getCookie('token')
      }

      let that = this

      this.$socket.emit('get-data', data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type)
          that.SET_ISADMIN(data.isSuperAdmin)
          that.SET_FIRSTNAME(data.firstname)
          that.SET_LASTNAME(data.lastname)
          that.SET_NAME(data.firstname + ' ' + data.lastname)
          that.SET_EMAIL(data.email)
          that.SET_PHONE(data.phone)
          that.SET_POSITION(data.position)
          that.SET_DEPARTMENT(data.department)
          that.SET_COUNTRY(data.country ? data.country : '')
          that.SET_DATE_CREATED(data.date_created)
          that.SET_PHOTO(data.photo)
          that.UPDATE_TOTAL_SPACE(data.total_space)
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used)
          that.UPDATE_USER(data.id)
          that.SET_CURRENT_PLAN(data.current_plan)
          that.SET_USER_PLAN(data.user_plan)
          that.SET_PLAN_STATUS(data.isPlanActive)
          that.SET_TRIAL_STATUS(data.isTrialActive)
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          that.SET_ISTRIAL(data.isTrial)
          that.SET_ISSTAFF(data.isStaff)
          that.SET_ISSUPERADMIN(data.isSuperAdmin)

          that.SET_IS_SECURITY_QUESTION(data.is_security_question)

          that.UPDATE_DEFAULT_FOLDER(data.default_folders)

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id)

          localStorage.setItem('email', data.email)
          localStorage.setItem('is_security_question', data.is_security_question)
          sessionStorage.setItem('gi', data.group_folder_id)
          sessionStorage.setItem('pi', data.project_folder_id)

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images)
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents)
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders)
        } else {
          that.$router.push('/login')
        }
      })
    }
  },
  mounted() {
    this.$refs.loading.load()
    this.user_data()

    let that = this
    let data = {
      token: cookies.getCookie('token'),
      load_plan: true
    }

    this.$socket.emit('url:auth', data, (data) => {
      if (data.data === false) {
        that.$router.push('/login')
      } else {
        that.$refs.loading.close()
        that.account_type = data.account_type
        that.current_plan = data.current_plan.name
        that.is_trial = data.is_trial
        that.total_space = data.total_space
        that.days_left = data.days_left
        that.is_subscription_active = data.is_subscription_active
        that.expiration_date = data.expiration_date
        that.user_plan = data.user_plan
        setTimeout(function () {
          that.loader = false
        }, 3000)
      }
    })
  }
}
</script>
